/**
 * @generated SignedSource<<2926080dc27be56ec75d8fe23a0e3090>>
 * @relayHash c853d0381ad6e1f26df50534fcfc985d
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID c853d0381ad6e1f26df50534fcfc985d

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "BasicResponse",
    "kind": "LinkedField",
    "name": "retryUpdateContractFromOmg",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RetryUpdateContractFromOMGMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RetryUpdateContractFromOMGMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "c853d0381ad6e1f26df50534fcfc985d",
    "metadata": {},
    "name": "RetryUpdateContractFromOMGMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

node.hash = "463527feab0c84379d16ea4bd6bbd8ff";

export default node;
